import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: '首页' },
    { path: '/category', label: '分类浏览' },
    { path: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-tight transition-colors duration-300 ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}>
              52662鼎盛平台
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium whitespace-nowrap transition-colors duration-200 group ${
                  scrolled
                    ? isActive(link.path) ? 'text-primary-600' : 'text-foreground-700 hover:text-foreground-950'
                    : isActive(link.path) ? 'text-white' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
                <span
                  className={`absolute -bottom-1 left-0 h-0.5 bg-primary-500 transition-all duration-300 rounded-full ${
                    isActive(link.path) ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}
                />
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className="whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              官方下载
            </a>
            <a
              href="#register"
              className={`whitespace-nowrap px-5 py-2.5 rounded-full text-sm font-semibold border transition-all duration-200 cursor-pointer ${
                scrolled
                  ? 'border-foreground-300 text-foreground-800 hover:border-foreground-500 hover:text-foreground-950'
                  : 'border-white/40 text-white hover:border-white hover:bg-white/10'
              }`}
            >
              立即注册
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-foreground-900' : 'text-white'}`} />
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium px-3 py-2 rounded-lg transition-colors duration-200 whitespace-nowrap ${
                  isActive(link.path)
                    ? 'bg-primary-50 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 pt-2 border-t border-background-200/70">
              <a
                href="#download"
                className="flex-1 text-center whitespace-nowrap px-4 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 cursor-pointer"
              >
                官方下载
              </a>
              <a
                href="#register"
                className="flex-1 text-center whitespace-nowrap px-4 py-2.5 rounded-full text-sm font-semibold border border-foreground-300 text-foreground-800 hover:border-foreground-500 transition-all duration-200 cursor-pointer"
              >
                立即注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}